export const MetaDataProperties = {
  IS_RENDER_RAW_HTML_ENABLED: 'renderRawHtml',
  IS_ALLOW_COOKIE_RESET_ENABLED: 'allowCookieReset',
  INBOX_ID: 'inboxId'
};